export default __webpack_public_path__ + "static/bg-16f79cc3f835143bc5065a4f74e8e9bb.jpg";